var $cbc6af0cc98fad10$exports = {};
$cbc6af0cc98fad10$exports = {
  "breadcrumbs": "\u30D1\u30F3\u304F\u305A\u30EA\u30B9\u30C8"
};
export { $cbc6af0cc98fad10$exports as default };